const OPEN_EDIT_DIALOG = 'OPEN_EDIT_DIALOG';
const CLOSE_EDIT_DIALOG = 'CLOSE_EDIT_DIALOG';

const TYPE_PROPERTIES_LOADED = 'TYPE_PROPERTIES_LOADED';

const editDialog = {
    open: false,
    id: 0
};


export const openEditDialog = id => ({
    type: OPEN_EDIT_DIALOG,
    payload: { open : true, id : id }
});

export const closeEditDialog = () => ({
    type: CLOSE_EDIT_DIALOG,
    payload: {...editDialog}
});

export default function editDialogReducer(state ={...editDialog}, { type, payload }) {
    const actions = {
        [OPEN_EDIT_DIALOG] : () => ({...state, ...payload }),
        [CLOSE_EDIT_DIALOG] : () => ({...state, ...payload })
    }

    return actions[type]?.call() || state;
}